<template>
  <div class="content-transation-detial">
    <div class="global-content-detail">
      <div ref="searchTransation" v-if="!bSkeleton">
        <div class="content-search-transation-detail">
          <div class="content-text-title">
            <v-icon class="global-icon-arrow-back" @click="back()">
              mdi-arrow-left
            </v-icon>
            <p class="main-text-title">Detalle de: {{ sNameDetail }}</p>
          </div>
          <div v-if="sIdOP" class="content-btn-detail-transation">
            <v-btn
              @click="setDetailOperation()"
              class="btn-add-global global-btn-primary"
            >
              Detalle de operación
            </v-btn>
          </div>
        </div>
        <v-breadcrumbs :items="itemsBreadcrumbs" divider="/"> </v-breadcrumbs>
      </div>
      <!--#region DATOS INFORMATIVOS -->
      <div class="content-identification-information">
        <p class="text-identification-information">Datos informativos</p>
        <v-container fluid>
          <v-row>
            <!-- #region LABELS AND TEXTS-FIELDS  -->

            <!-- #region IDENTIFICADOR DE TRANSACCION  -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <!-- v-if="!bModify" -->
              <div>
                <p class="text-title">Identificador de transacción</p>
                <p class="text-information">
                  {{ oItemInformationDate.sFolio }}
                </p>
              </div>
            </v-col>
            <!-- #endregion IDENTIFICADOR DE TRANSACCION  -->

            <!-- #region TIPO  DE TRANSACCIÓN  -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Tipo de transacción</p>
                <p class="text-information">
                  {{ oItemInformationDate.sTransactionType }}
                </p>
              </div>
            </v-col>
            <!-- #endregion TIPO  DE TRANSACCIÓN -->

            <!-- #region CANTIDAD ASOCIADA -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Cantidad asociada</p>
                <p class="text-information">
                  $ {{ formatMoneyGlobal(oItemInformationDate.dAmount) }}
                  {{ sCurrencyCode }}
                </p>
              </div>
            </v-col>
            <!-- #endregion CANTIDAD ASOCIADA -->

            <!-- #region Nombre del beneficiario -->
            <v-col
              v-if="oItemInformationDate.sBeneficiaryName"
              cols="12"
              sm="3"
              md="3"
              lg="3"
              xl="3"
            >
              <div>
                <p class="text-title">Nombre del beneficiario</p>
                <p class="text-information">
                  {{ oItemInformationDate.sBeneficiaryName }}
                </p>
              </div>
            </v-col>
            <!-- #endregion Nombre del beneficiario -->

            <!-- #region TIPO DE REGISTRO -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Tipo de registro</p>
                <p class="text-information">
                  {{ oItemInformationDate.eRegistrationType }}
                </p>
              </div>
            </v-col>
            <!-- #endregion TIPO DE REGISTRO -->

            <!-- #region FECHA DE  TRANSACCIÓN -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Fecha de transacción</p>
                <p class="text-information">
                  {{ oItemInformationDate.tTransactionDate }}
                </p>
              </div>
            </v-col>
            <!-- #endregion FECHA DE TRANSACCIÓN -->

            <!-- #region INGRESO DE TRNAS. EN EL SISTEMA -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Fecha de registro</p>
                <p class="text-information">
                  {{ oItemInformationDate.created_at }}
                </p>
              </div>
            </v-col>
            <!-- #endregion INGRESO DE TRNAS. EN EL SISTEMA -->

            <!-- #region DESCRIPCIÓN DE LA TRANSACCION -->
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div>
                <p class="text-title">Descripción</p>
                <p class="text-information">
                  {{ oItemInformationDate.sDescription }}
                </p>
              </div>
            </v-col>
            <!-- #endregion DESCRIPCIÓN DE LA TRANSACCION -->

            <!-- #endregion LABELS TEXTS-FIELDS -->
          </v-row>
        </v-container>
        <v-divider class="divider-global mt-9"></v-divider>
      </div>
      <!--#endregion DATOS INFORMATIVOS -->

      <!--#region INFORMACIÓN DEL RESPONSABLE  -->
      <div class="content-identification-information">
        <p class="text-identification-information">
          Información del responsable
        </p>
        <v-container fluid>
          <v-row>
            <!-- #region LABELS AND TEXTS-FIELDS   -->
            <!-- #region EMPLEADO QUE REALIZO LA TRANS  -->
            <!-- v-if="!bModify" -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Registrada por</p>
                <p class="text-information">
                  {{ oItemResponsableInfromation.sUserFullName }}
                </p>
              </div>
            </v-col>
            <!-- #endregion IDENTIFICADOR DE TRANSACCION  -->

            <!-- #region TELEFONO DEL RESPONSABLE  -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Teléfono del responsable</p>
                <p class="text-information">
                  {{ oItemResponsableInfromation.sUserPhoneNumber }}
                </p>
              </div>
            </v-col>
            <!-- #endregion TIPO  DE TRANSACCIÓN -->

            <!-- #region CORREO ELECTRONICO -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Correo electrónico</p>
                <p class="text-information">
                  {{ oItemResponsableInfromation.sUserEmail }}
                </p>
              </div>
            </v-col>
            <!-- #endregion CANTIDAD ASOCIADA -->

            <!-- #region CLIENTE ASOCIADO -->
            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
              <div>
                <p class="text-title">Cliente asociado</p>
                <p
                  v-if="oItemResponsableInfromation.AsocCustomer"
                  class="text-information"
                >
                  {{ oItemResponsableInfromation.AsocCustomer }}
                </p>
                <p class="text-data-empty">
                  {{ sEmptyDataGlobal }}
                </p>
              </div>
            </v-col>
            <!-- #endregion TIPO DE REGISTRO -->

            <!-- #endregion LABELS TEXTS-FIELDS  -->
          </v-row>
        </v-container>
        <v-divider class="divider-global mt-9"></v-divider>
      </div>
      <!--#endregion INFORMACIÓN DEL RESPONSABLE -->
    </div>
    <!-- <footer-component-global /> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      screenHeight: 0,
      heightMax: 0,
      bSkeleton: true,
      oItemInformationDate: {},
      oItemResponsableInfromation: {},
      itemsBreadcrumbs: [],
      sCurrencyCode: "",
      bShowBtnDetailOperation: true,
      sIdOP: "",
    };
  },
  mounted() {
    this.matchHeight();
    this.handleResize();
  },
  updated() {
    this.matchHeight();
  },
  beforeMount() {
    this.$store
      .dispatch("getPermissionsByUserGlobal")
      .then((resp) => {
        this.setNameBreadcrumbs();
        this.getTransationDetail();
      })
      .catch((err) => {
        this.Error(err);
      });
  },
  created() {
    window.addEventListener("resize ", this.matchHeight);
    this.matchHeight();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.addEventListener("resize ", this.matchHeight);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    back() {
      if (this.fromRoute == "expenses") {
        this.$router.push("/home/income_and_expenses/expenses").catch(() => {});
      } else {
        this.$router.push("/home/income_and_expenses/incomes").catch(() => {});
      }
    },
    setNameBreadcrumbs() {
      var aFromInitial = null;
      if (this.fromRoute == "expenses") {
        aFromInitial = {
          text: "Egresos",
          link: true,
          exact: true,
          disabled: false,
          to: "/home/income_and_expenses/expenses",
        };
      } else {
        aFromInitial = {
          text: "Ingresos",
          link: true,
          exact: true,
          disabled: false,
          to: "/home/income_and_expenses/incomes",
        };
      }
      let aBreadcrumbs = [];
      aBreadcrumbs.push(aFromInitial);
      aBreadcrumbs.push({
        text: "Detalle de transacción",
        link: true,
        exact: true,
        disabled: true,
      });
      this.itemsBreadcrumbs = aBreadcrumbs;
    },
    matchHeight() {
      if (this.$refs.searchTransation !== undefined) {
        this.heightMax = this.$refs.searchTransation.clientHeight;
        this.heightMax = this.heightMax + 123;
      }
      if (window.innerWidth > 600) {
        this.screenHeight = window.innerHeight - 100;
      } else {
        this.screenHeight = window.innerHeight - 100;
      }
    },
    handleResize: function () {
      this.matchHeight();
    },
    colorTransationType(sTransactionType) {
      if (sTransactionType === "DEPOSIT") {
        return "#00A85B";
      } else {
        return "#E85353";
      }
    },
    goToUser(sUserId) {
      this.$router
        .push(
          `/home/account-detail/${this.$route.params.id}/transation/${this.$route.params.idTransation}/user-profile-detail-account/${sUserId}`
        )
        .catch(() => {});
    },
    getTransationDetail() {
      const payload = {},
        config = {
          headers: {
            Authorization: "Bearer " + this.$store.state.sToken,
            contentType: "application/x-www-form-urlencoded;charset=utf-8",
          },
        };
      DB.get(
        `${URI}/api/sp/v1/accounts/${this.$route.params.id}/transactions/${this.$route.params.idTransation}`,
        config,
        payload
      )
        .then((response) => {
          if (response.data.results.oOrder.sOrderId) {
            this.sIdOP = response.data.results.oOrder.sOrderId;
          }
          this.oItemInformationDate = response.data.results;
          this.sCurrencyCode = this.oItemInformationDate.oCurrency.sCode;
          this.oItemResponsableInfromation = response.data.results.oUser;
          this.$store.commit(
            "setsNameDetail",
            this.oItemInformationDate.sFolio
          );
          this.bSkeleton = false;
          this.$store.commit("refresher", false);
        })
        .catch((error) => {
          this.Error(error.response.data);
        });
    },
    setDetailOperation() {
      this.$router.push({
        name: "OPDetailTransactionDetail",
        params: {
          id: this.$route.params.id,
          idTransation: this.$route.params.idTransation,
          from: this.$route.params.from,
          idOP: this.sIdOP,
        },
      });
      // this.$router
      //   .push(
      //     `/home/account-detail/${this.$route.params.id}/transation/${this.$route.params.idTransation}/op-detail-transition-detial-account/${this.oItem.oOrder.sOrderId}`
      //   )
      //   .catch(() => {});
    },
  },
  computed: {
    sNameDetail() {
      return this.$store.state.sNameDetail;
    },
    fromRoute() {
      return this.$route.params.from;
    },
    sEmptyDataGlobal() {
      return this.$store.state.sEmptyDataGlobal;
    },
  },
};
</script>

<style scoped>
.content-identification-information {
  margin-bottom: 25px;
  padding: 0px 0px 0px 12px;
}

.text-identification-information {
  color: var(--primary-color-color-title-information);
  font-family: "pop-Bold";
  font-size: 16px;
  letter-spacing: 3px;
}

.text-title {
  margin-bottom: 2px;
  color: var(--primary-color-text-title-detail);
  font-family: "pop-Regular";
  opacity: 1;
  letter-spacing: 0px;
}

.text-information {
  margin-bottom: 5px;
  color: var(--primary-color-text);
  font-family: "pop-Regular";
}

.content-btns-accions {
  display: flex;
  padding: 0px 0px 0px 12px;
  margin-top: 25px;
  margin-bottom: 5px;
  width: 100% !important;
}

.content-btn-primary {
  width: 200px;
}

.content-btn-second {
  width: 200px;
  margin-right: 15px;
}

.text-identification {
  margin-bottom: 0px;
  color: var(--primary-color-text);
}

.text-icon-launch {
  color: var(--primary-color-link);
  /* margin-top: -5px; */
  font-size: 20px;
  cursor: pointer;
}
</style>

<style scoped>
.content-search-transation-detail {
  display: flex;
  align-content: center;
  justify-content: space-between;
  width: 100%;
}
.content-text-title {
  display: flex;
}
.main-text-title {
  color: var(--primary-color-text);
  font-family: "pop-SemiBold";
  font-size: 2rem;
  margin-bottom: 0px;
  margin-right: 5px;
}

/* XS */
@media (max-width: 599px) {
  .demoColorResponsive {
    background-color: rgb(190, 136, 226);
  }
}
/* SM */
@media (min-width: 600px) and (max-width: 959px) {
}
/* MD */
@media (min-width: 960px) and (max-width: 1264px) {
  .demoColorResponsive {
    background-color: rgb(201, 122, 83);
  }
}
/* LG */
@media (min-width: 1264px) and (max-width: 1904px) {
  .demoColorResponsive {
    background-color: rgb(204, 198, 109);
  }
}
/* XL */
@media (min-width: 1904px) {
  .demoColorResponsive {
    background-color: rgb(113, 199, 201);
  }
}
</style>
